// src/components/shared/UpdateSection.jsx
import React, { useState, useMemo } from "react";

export default function UpdateSection({ updateKey, updates, userEmail, onSaveUpdate, onDeleteUpdate }) {
  const [text, setText] = useState("");
  const [hoverDelete, setHoverDelete] = useState(null);

  const saved = useMemo(() => {
    const list = updates[updateKey] || [];
    return [...list].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  }, [updates, updateKey]);

  function handleSave() {
    if (!text.trim()) return;
    const newUpdate = {
      timestamp: new Date().toISOString(),
      email: userEmail,
      text: text.trim(),
    };
    onSaveUpdate(updateKey, newUpdate);
    setText("");
  }

  function handleDelete(timestamp) {
    if (!window.confirm("Weet je zeker dat je deze update wilt verwijderen?")) return;
    onDeleteUpdate(updateKey, timestamp);
  }

  return (
    <div>
      <div className="text-sm font-semibold uppercase tracking-wide text-slate-600 mt-3 mb-1">
        Update
      </div>
      <textarea
        className="w-full rounded-lg p-2 border border-gray-200 text-sm"
        placeholder="Geef een update over deze deliverable…"
        rows={3}
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{ color: "#000000", backgroundColor: "#ffffff" }}
      />
      <div className="flex justify-end">
        <button
          type="button"
          onClick={handleSave}
          style={{
            background: "#31719D",
            color: "#ffffff",
            fontSize: "11px",
            padding: "3px 10px",
            borderRadius: "6px",
            fontWeight: 600,
            border: "none",
            cursor: "pointer",
            marginTop: "4px",
          }}
        >
          Opslaan
        </button>
      </div>

      {saved.length > 0 && (
        <div className="mt-2 space-y-1">
          {saved.map((u, i) => {
            const d = new Date(u.timestamp);
            const dateStr = d.toLocaleDateString("nl-NL", {
              day: "numeric",
              month: "long",
              year: "numeric",
            });
            const timeStr = d.toLocaleTimeString("nl-NL", {
              hour: "2-digit",
              minute: "2-digit",
            });
            const isOwn = u.email === userEmail;
            return (
              <details
                key={i}
                style={{
                  background: "#f8fafc",
                  border: "1px solid #f3f4f6",
                  borderRadius: "0.5rem",
                  padding: "0.5rem",
                  marginTop: "0.25rem",
                }}
              >
                <summary className="text-xs text-slate-600 cursor-pointer" style={{ listStyle: "none" }}>
                  <div className="flex items-center justify-between gap-2">
                    <span>▸ {dateStr}, {timeStr} — {u.email}</span>
                    {isOwn && (
                      <button
                        type="button"
                        onClick={(e) => { e.preventDefault(); handleDelete(u.timestamp); }}
                        onMouseEnter={() => setHoverDelete(i)}
                        onMouseLeave={() => setHoverDelete(null)}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "14px",
                          color: hoverDelete === i ? "#ef4444" : "#94a3b8",
                          padding: "0 2px",
                          lineHeight: 1,
                        }}
                        title="Update verwijderen"
                      >
                        🗑
                      </button>
                    )}
                  </div>
                </summary>
                <p className="text-sm text-slate-700 mt-1 whitespace-pre-wrap">{u.text}</p>
              </details>
            );
          })}
        </div>
      )}
    </div>
  );
}
